import { createSlice } from '@reduxjs/toolkit';
import { loginUserOnComet } from '../../utils';

const initialState = {
  isAuthenticated: false,
  isLoading: false,
  error: null,
  userData: {},
  token: "",
  refreshToken: null,
  isOtpSent: false,
  deleteRequestModal: {
    isOpen: false,
    message: ''
  },
   showPendingAppointmentsModal: false,
   expiredPendingAppointments: [], 
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setPendingAppointmentsModal(state, action) {
  state.showPendingAppointmentsModal = action.payload;
},
setExpiredPendingAppointments(state, action) {
  state.expiredPendingAppointments = action.payload;
},
    loginStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
       state.showPendingAppointmentsModal = false;  
  state.expiredPendingAppointments = [];
      state.userData = action.payload;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
      state.isLoading = false;
      state.error = null;
      state.isOtpSent = false; 
      try {
        if (state.userData.userType) {
          loginUserOnComet(state.userData.userType, state.userData, () => { })
        }
      } catch (error) {
      }
    },
    loginFailure(state, action) {
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = action.payload;
      state.isOtpSent = false;
    },
    tokenRefreshed(state, action) {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.token = null;
    },
    doctorLogout(state) {
      state.isAuthenticated = false;
      state.token = null;
    },
    organizationlogout(state){
      state.isAuthenticated = false;
      state.token = null;
    },
    subadminlogout(state){
      state.isAuthenticated = false;
      state.token = null;
    },
    setOtpSent(state, action) {
      console.log('Action Payload in setOtpSent:',state, action.payload);
      state.isOtpSent = action.payload;
      state.error = null; 
    },
    clearOtpState(state) {
      state.isOtpSent = false;
      state.error = null;
    },
     showDeleteRequestModal(state, action) {
      state.deleteRequestModal.isOpen = true;
      state.deleteRequestModal.message = action.payload;
    },
    hideDeleteRequestModal(state) {
      state.deleteRequestModal.isOpen = false;
      state.deleteRequestModal.message = '';
    }

  },
});

export const { loginStart, loginSuccess, loginFailure,tokenRefreshed, logout, doctorLogout, organizationlogout, subadminlogout, setOtpSent,
  clearOtpState, showDeleteRequestModal,
  hideDeleteRequestModal, setPendingAppointmentsModal,      setExpiredPendingAppointments,     } = authSlice.actions;

export default authSlice.reducer;
